import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-customerview',
  templateUrl: './customer-view.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerviewComponent implements OnInit {

  permision : string[] = [];
  currentuser : any = {};
  allowed = true;
  flagging:any = {};

  ViewCustomer: any = [];
  ViewCustomeratvorder: any = [];
  Viewless: any = [];
  actionHistory: any = [];
  listservices: any = [];
  listlogservices: any = [];
  listlogprepaidinvoice: any = [];
  liststb: any = [];
  liststbcust: any = [];
  userinfo : [];
  Billing: any = [];
  itemchange: any = {};

  btnchange = false;
  showuserinfo = false;
  openInfoUser = false;
  alert_success = false;
  alert_failed = false;

  showin = true;

  alert_act='';

  formCust = this.fb.group({
    nama: [''],
    nik: [''],
    tlp: [''],
    tlp2: [''],
    email: [''],
    email2: [''],
    alamat: [''],
    kota: [''],
    partnername: [''],
    notes: [''],

  })
 
  formChange = this.fb.group({
    nama: [''],
    id: [''],
    billingtype: [''],
    notes: [''],

  })
 
 subservices:any = [];

  constructor(
	  private route: ActivatedRoute,
	  private router: Router,
    public LoadJsOrder: LoadJsService,
    private fb: FormBuilder,
	  public partnerService: ApiPartnerService,
    private Auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.permision = this.currentuser.permision;
  	this.loadStart();
    this.setflag('atvinfo','open',true);
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
    //alert(id);
    this.loadBilling();
  	this.loadCustomer(id);
    this.loadsubLayanan(id);
    this.loadServiceHistory(id);
    this.loadPrepaidInvoiceHistory(id);
    this.loadCustomerATVORDER(id);
    this.checkbillingtype();
  }

  loadsubLayanan(id)
  {
    return this.partnerService.GetSubServiceCustomer('?id='+id).subscribe((output: any) => {
      // console.log(output);
      this.subservices = output.data;
      
    });
  }

  viewdataorder(datatype,val){

    if ( this.ViewCustomeratvorder[datatype] == undefined ){
      return '--';
    }else{
      return this.ViewCustomeratvorder[datatype][val];
    }

  }

  onActionClick(act:any, item: any)
  {
    // console.log(item);
    this.alert_act = act;

    if ( act == "update") {
      console.log(item)
      this.loadLess(item)
    }
    else if ( act == "changebilling" ) {
      console.log(item)

      this.showin = true

      this.formChange.get('nama').setValue(item.nama)
      this.formChange.get('id').setValue(item.id)
      this.formChange.get('billingtype').setValue(item.billingtype)
      this.formChange.get('notes').setValue('')
      
    }
  }

  btntoggle(){
    this.showin = false
  }

  checkbillingtype(){
    if(this.ViewCustomer.billingtype == 1){
      return true
    }else{
      return false
    }
  }

  loadBilling() {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      this.Billing = output.data;
    })
  }

  loadCustomer(id: any) {
    this.setflag('view','loading',true);
    return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
      if ( output.status == true ){ 
        this.setflag('view','allowed',true);
        this.ViewCustomer = output.data;
        this.listservices = output.data.services;
        this.liststb = output.data.stb;
        this.liststbcust = output.data.stbcust;
        this.actionHistory = output.data.actionHistory;
        this.loadServices(id);
      }else{
        this.setflag('view','allowed',false);
      }
       this.setflag('view','loading',false);
    })
  }

  loadServices(id: any){
    
    this.partnerService.GetCustomerService('?id='+id).subscribe((output: any) => {
      //console.log(output);
      this.listservices = output.data;
    })
  }

  loadCustomerATVORDER(id: any) {
   // this.setflag('view','loading',true);
    return this.partnerService.GetViewCustomeratvorder(id).subscribe((output: any) => {
      if ( output.status == true ){ 
        this.ViewCustomeratvorder = output.data;
      }
     // this.setflag('view','loading',false);
    })
  }


  loadServiceHistory(id) {
    return this.partnerService.GetServiceHistory(id).subscribe((output: any) => {
      console.log(output);
       this.listlogservices = output.data;
    })
  }

  loadPrepaidInvoiceHistory(id) {
    return this.partnerService.GetPrepaidinvoiceHistory(id).subscribe((output: any) => {
      console.log(output);
       this.listlogprepaidinvoice = output.data;
    })
  }


  loadLess(item: any) {
    return this.partnerService.GetViewless(item.id).subscribe((output: any) => {
    console.log(output);
       this.Viewless = output.data;

       this.formCust.setValue(this.Viewless);

    })
  }

  openATVORDER(){
    this.setflag('atvorder','open',true);
    this.setflag('atvinfo','open',false);
    this.setflag('atvactive','open',false);
  }

  openATVACTIVE(){
    this.setflag('atvactive','open',true);
    this.setflag('atvinfo','open',false);
    this.setflag('atvorder','open',false);
  }
  openATVINFO(){
    this.setflag('atvinfo','open',true);
    this.setflag('atvorder','open',false);
    this.setflag('atvactive','open',false);
  }

  submitUpdate(item: any) {
    return this.partnerService.updatecustomer(item.id, this.formCust.value).subscribe((output: any) => {
    // console.log(output.data)

    // console.log('masuk', this.formCust.value.nama)
      if ( output.status ){
        
        this.ngOnInit()
        console.log("masuk")

        this.LoadJsOrder.loadScriptProductStb()

        this.alert_success = true
        
        setTimeout(()=>{
          this.alert_success = false
        }, 6000);

      } else {
        console.log("gagal")

        this.LoadJsOrder.loadScriptProductStb()
        this.alert_failed = true
        
        setTimeout(()=>{
          this.alert_failed = false
        }, 6000);
      }      
    
    })
  }

  submitChange(item: any) {

    console.log(item)

    return this.partnerService.Changebillingcust(item.id, this.formChange.value).subscribe((output: any) => {
      if ( output.status ){
        
        this.ngOnInit()
        console.log("masuk")

        this.LoadJsOrder.loadScriptProductStb()

        this.alert_success = true
        
        setTimeout(()=>{
          this.alert_success = false
        }, 6000);

      } else {
        console.log("gagal")

        this.LoadJsOrder.loadScriptProductStb()
        this.alert_failed = true
        
        setTimeout(()=>{
          this.alert_failed = false
        }, 6000);
      }      
    
    })
  }

  Showatvuserid()
  {
    this.openInfoUser  = false;
    return this.partnerService.ATVShowUserId({sn:this.liststb.sn}).subscribe((output: any) => {
      console.log(output); 
      this.showuserinfo  = true;
      this.openInfoUser  = true;

      if (output.data == null){
        this.userinfo = [];

      }else{
        this.userinfo = output.data[0];

      }
       console.log(this.userinfo);  
    })
  }

  showuser(x)
  {
    console.log(this.userinfo);
    console.log(x);
    if ( this.userinfo == undefined ){
      return '';
    } else {
      if (this.userinfo[x] == undefined){
        return '';
      }else{
        return this.userinfo[x];
      }
    }
  }

  MyPermission(p)
  {
    if ( this.permision == undefined ){
      return false;
    }

    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }
  }

  setflag(id,key,val)
  {
    console.log(id,key,val);
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if ( this.flagging[id][key] == undefined){
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    console.log(this.flagging[id]);
  }

  flag(id,key){
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    }else if (this.flagging[id][key] == undefined ) {
      this.flagging[id][key] = false;
    }

//    console.log(this.flagging[id]);
//    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

}
